import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
const HistoryPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight:'100vh', background:'var(--bg)' }}>
      <div style={{ position:'fixed', top:0, left:0, right:0, zIndex:100, background:'rgba(10,14,26,.95)', backdropFilter:'blur(12px)', borderBottom:'1px solid var(--border)', height:52 }}>
        <div style={{ maxWidth:520, margin:'0 auto', padding:'0 16px', height:'100%', display:'flex', alignItems:'center', gap:12 }}>
          <button onClick={() => navigate('/dashboard')} style={{ background:'transparent', border:'none', color:'var(--muted)', cursor:'pointer', display:'flex', alignItems:'center', gap:6, fontSize:13, fontWeight:600 }}>
            <ArrowLeft size={16}/> Orqaga
          </button>
        </div>
      </div>
      <div style={{ display:'flex', justifyContent:'center', alignItems:'center', height:'80vh', color:'var(--muted)' }}>Tez orada...</div>
    </div>
  );
};
export default HistoryPage;
